import axios from 'axios';

export const setAxiosAuth = (accessToken: string) => {
  if (!accessToken) return;
  axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
}
